<!--
  Statische "Promo"-Kachel im Look der Reiseziel-Karten (TravelPreview.vue),
  führt aber zu einer internen Seite (z. B. Anfrage-/Kontaktformular) statt zu
  einem Reiseziel. Wird auf der Startseite und der Urlaubsziele-Übersicht
  jeweils ans Ende der Kachel-Reihe gehängt.

  Bild austauschen: einfach das `image`-Prop beim Einbinden anpassen
  (Datei unter public/images/ ablegen).
-->
<template>
  <div class="card card-travel-preview card-vacation-destination">
    <Link :href="$route(routeName)">
      <img :src="image" class="card-img-top" :alt="title" />
    </Link>
    <div class="card-body">
      <h5 class="card-title mt-4 mb-3">{{ title }}</h5>
      <div class="card-text">{{ text }}</div>
    </div>
    <div class="card-footer">
      <Link
        :href="$route(routeName)"
        class="btn btn-outline-primary rounded-pill mb-4"
      >
        <i class="fas fa-skiing me-2"></i> Details
      </Link>
    </div>
  </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Link,
  },
  props: {
    title: String,
    text: String,
    image: String,
    // Name der Ziel-Route, z. B. "future-destinations" oder "group-travel".
    routeName: String,
  },
};
</script>
